import React from 'react';

import Tag from './tag';
import { filterCustomFieldFilters } from './helpers';

import type { CustomFieldFiltersProps } from './types';

export default function CustomFieldFilterTags({
  changeFilter,
  filterFunction,
  filters,
  schemas
}: CustomFieldFiltersProps) {
  const tags: React.ReactElement[] = [];

  for (const slug in filterCustomFieldFilters(schemas, filters, filterFunction)) {
    const filter = filters[slug];
    const schema = schemas.find(schema => schema.slug === slug);
    if (schema) {
      tags.push(<Tag changeFilter={changeFilter} filter={filter} key={slug} schema={schema} />);
    }
  }

  return <>{tags}</>;
}
